import { SaleOrderBearingVisibility } from './sale-order-bearing-visibility';

export class SaleOrderBearing {
  constructor(
    public hash?: string,
    public saleOrderHash?: string,
    public bearingDate?: number,
    public observations?: string,
    public loadingCustomerHash?: string,
    public loadingCustomerBusinessName?: string,
    public loadingCustomerNif?: string,
    public loadingPlace?: string,
    public unloadingCustomerHash?: string,
    public unloadingCustomerBusinessName?: string,
    public unloadingPlace?: string,
    public unloadingCustomerNif?: string,
    public saleOrderBearingVisibilities?: SaleOrderBearingVisibility[]

  ) { }

  clone() {
    return new SaleOrderBearing(
      this.hash,
      this.saleOrderHash,
      this.bearingDate,
      this.observations,
      this.loadingCustomerHash,
      this.loadingCustomerBusinessName,
      this.loadingCustomerNif,
      this.loadingPlace,
      this.unloadingCustomerHash,
      this.unloadingCustomerBusinessName,
      this.unloadingPlace,
      this.unloadingCustomerNif,
      this.saleOrderBearingVisibilities
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-bearing.ts